import { defineStore } from 'pinia'
import { useUserStore } from "@/stores/user";

export const useInquiriesStore = defineStore('inquiries', {
  state: () => ({
    items: [],
    totalRecords: 0,
    loading: false,
    serverOptions: {
      page: 0,
      rows: 20,
    },
  }),
  actions: {
    kdnr() {
      return useUserStore().user.organisation?.kdnr || this.$router.currentRoute.value.query.kdnr
    },
    async index() {
      this.loading = true

      try {
        const response = await this.apiClientV2.get('/inquiries', {
          params: {
            kdnr: this.kdnr(),
            page: this.serverOptions.page + 1,
            size: this.serverOptions.rows,
          },
        })

        this.items = response?.data?.inquiries || []
        this.totalRecords = Number(response?.data?.pagination?.total_records || 0)
        return response
      } finally {
        this.loading = false
      }
    },
    async show(id) {
      const response = await this.apiClientV2.get(`/inquiries/${id}`, {params: {kdnr: this.kdnr()}})
      return response?.data?.inquiry
    },
  },
})
